import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from "./CodeLabel.module.scss";

export default class CodeLabel extends Component {
    render() {
        return (
            <span className={`${styles.label} ${this.props.className}`} title={this.props.code} onClick={this.props.onClick}>
                {this.props.code}
            </span>
        )
    }
}

CodeLabel.propTypes = {
    className: PropTypes.string,
    code: PropTypes.string,
    onClick: PropTypes.func
};